enum EditorModes {
  COMMENT = "comment",
  READ = "read",
  WRITE = "write",
}

export default EditorModes
